import notFoundHouse from 'assets/img/not-found-house.svg';
import {useTranslation} from 'react-i18next';
import {Wrapper, NotFoundIcon, Title, SecondText, Text} from './styled';

function NotFoundView() {
  const {t} = useTranslation();
  return (
    <Wrapper>
      <NotFoundIcon src={notFoundHouse} />
      <Title>{t('link_not_valid')}</Title>
      <Text>{t('not_found_has_missing')}</Text>
      <SecondText>{t('not_found_make_sure')}</SecondText>
    </Wrapper>
  );
}

export {NotFoundView};
